<template>
  <div class="contact" v-if="!thanks">
    <h1>Contact</h1>
    <form @submit.prevent="send()" method="post">
      <div class="grid">
        <div class="group-input">
          <label for="email">Email<span class="required">*</span></label>
          <input type="email" v-model="email" id="" />
        </div>
        <div class="group-input">
          <label for="name">Name</label>
          <input type="text" v-model="name" id="name" />
        </div>
        <div class="group-input">
          <label for="subject">Subject<span class="required">*</span></label>
          <input type="text" v-model="subject" id="subject" />
        </div>
        <div class="group-input">
          <label for="message">Message<span class="required">*</span></label>
          <textarea
            v-model="message"
            id="message"
            cols="30"
            rows="10"
          ></textarea>
        </div>

        <div class="group-input">
          <button type="submit">Send</button>
        </div>
      </div>
    </form>
  </div>
  <div class="contact thanks" v-if="thanks">
    <h1>Thank you for contacting me</h1>
    <p>I will reply as soon as possible</p>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      thanks: false,
      message: "",
      subject: "",
      name: "",
      email: "",
    };
  },
  methods: {
    send() {
      if (this.email == "") {
        alert("Please enter your email");
        return;
      }
      if (this.subject == "") {
        alert("Please enter the subject");
        return;
      }
      if (this.message == "") {
        alert("Please enter your message");
        return;
      }
      fetch("https://formsubmit.co/ajax/belboukayyoub@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          message: this.message,
          subject: this.subject,
          name: this.name,
          email: this.email,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            this.message = "";
            this.subject = "";
            this.name = "";
            this.email = "";
            this.thanks = true;
          }
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>
<style lang="scss">
.grid {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr;
  .group-input {
    label {
      color: #fdae57;
    }

    input,
    textarea {
      width: 100%;
      background-color: transparent;
      border: 1px solid white;
      padding: 5px;
      margin-top: 10px;
      color: #fdae57;
    }

    button {
      width: 50%;
      background-color: #fd7e14;
      color: white;
      padding: 5px;
      font-weight: bold;
      border: 1px solid white;
      cursor: pointer;
      &:hover {
        background-color: #fdae57;
        color: black;
        border: 1px solid #fd7e14;
      }
    }
    &:nth-child(3),
    &:nth-child(4) {
      grid-column: 1 / span 2;
    }
  }
}

@media screen and (max-width: 1024px) {
  .group-input {
    grid-column: 1 / span 2;
  }
}

.required {
  position: relative;
  margin-left: 3px;
  top: -3px;
  color: #fc7e15;
}

.contact.thanks {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: calc(100vh - 120px);
}
</style>
